import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
// CSS is loaded via src/scss/style.scss

document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.getElementById('vehicle-gallery');
  if (!gallery) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery:    '#vehicle-gallery',
    children:   'a[data-pswp-width]',
    pswpModule: PhotoSwipe,   // static import — no dynamic import() / import.meta.url
    bgOpacity:  0.95,
  });
  lightbox.init();

  const viewAllBtn = document.getElementById('vehicle-gallery-all');
  if (viewAllBtn) {
    viewAllBtn.addEventListener('click', () => lightbox.loadAndOpen(0));
  }
});
